import { Error } from 'components';
import { useAnalytics } from 'hooks';
import { Layout } from 'layouts';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

export const ScreensError = (props) => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.screenViewedError(props.errorMessage);
  }, [analytics, props.errorMessage]);

  return (
    <Layout showBackButton={false}>
      <Error {...props} />
    </Layout>
  );
};

ScreensError.propTypes = {
  errorMessage: PropTypes.string,
};

export default ScreensError;
